import { createAction } from 'redux-actions';

import * as types from './actionTypes';

export const setOpenedTableRows = createAction(types.SET_OPEN_TABLE_ROWS, (tableId, rows) => ({ tableId, rows }));

export const removeOpenedRows = createAction(types.REMOVE_TABLE, (tableId) => ({ tableId }));
